import { render, staticRenderFns } from "./ClosingLevelFormItem.vue?vue&type=template&id=c3a175a0&"
import script from "./ClosingLevelFormItem.vue?vue&type=script&lang=ts&"
export * from "./ClosingLevelFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports